import { BlockFaqType } from '../../models/Content';
import { FaqContent } from './model';

export const transformBlockFaq = (content: BlockFaqType): FaqContent => {
    const faqItems = content.fields.faqItems || [];

    return {
        id: content.sys.id,
        title: content.fields.title,
        colorOption: content.fields.colorOption,
        items: faqItems.map((item) => ({
            id: item.sys.id,
            title: item.fields.title,
            content: item.fields.content,
        })),
    };
};
